import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getTotalUsers: async (querys) => {
    const url = urlQueryData(`${API_URL}/IdentityManagement/api/amx/cpe/users/internal/total`, querys)
    // return fetchManager(url)
    const response = await fetchManager(url)
    return response
  },
  getUsers: async (querys) => {
    const url = urlQueryData(`${API_URL}/IdentityManagement/api/amx/cpe/users/internal`, querys)
    // return fetchManager(url)
    const response = await fetchManager(url)
    return response
  },
  changeStatusUser: async (email, body) => {
    const response = fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/users/internal/status/${email}`, {
      method: 'PATCH',
      data: body
    })
    return response
  },
  getTotalBulkLoad: (querys) => {
    const url = urlQueryData('IdentityManagement/api/amx/cpe/users/internal/upload/report/total', querys)
    // return fetchManager(url)
    fetchManager(url)
    return { total: 1234 }
  },
  getListInternalUserLoads: async (querys) => {
    const url = urlQueryData(`${API_URL}/LoadManagement/api/amx/cpe/users/internal/upload/report`, querys)
    // return fetchManager(url)
    const response = await fetchManager(url)
    return response
  },
  getDetailUpload: async (id) => {
    const response = await fetchManager(`${API_URL}/LoadManagement/api/amx/cpe/users/internal/upload/summary/${id}`)
    return response
  },
  getDetailLoadInternal: async (id) => {
    const response = await fetchManager(`${API_URL}/LoadManagement/api/amx/cpe/users/internal/upload/report/detail/${id}`, { isFile: true })
    return response
  },
  rejectUpload: async (id, data) => {
    const response = await fetchManager(`${API_URL}/LoadManagement/api/amx/cpe/users/internal/upload/${id}`, {
      method: 'PATCH',
      data
    })
    return response
  },
  executeUpload: async (id, data) => {
    const response = await fetchManager(`${API_URL}/LoadManagement/api/amx/cpe/users/internal/upload/${id}`, {
      method: 'PATCH',
      data
    })
    return response
  },
  preloadInternalUsers: async (data) => {
    const response = await fetchManager(`${API_URL}/LoadManagement/api/amx/cpe/users/internal/upload/summary`, {
      method: 'POST',
      data
    })
    return response
  },
  getReportTotalInternalByCountry: async () => {
    const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/reports/users/internal/total`)
    return response
  },
  getReportTotalSupplierByCountry: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/suppliers/total`)
    return response
  },
  reportTotalInternalByCountry: async () => {
    const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/reports/users/internal/total/export`, { isFile: true })
    return response
  },
  reportDetailInternal: async () => {
    const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/reports/users/internal/detail/export`, { isFile: true })
    return response
  },
  reportTotalSupplierByCountry: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/suppliers/total/export`, { isFile: true })
    return response
  },
  reportDetailSupplier: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/suppliers/detail/export`, { isFile: true })
    return response
  },
  getReportTotalFoliosPRGEH: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/prgeh/total`)
    return response
  },
  getReportTotalFoliosPDD: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pdd/detail`)
    return response
  },
  getReportTotalFoliosPDDC: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pddc/detail`)
    return response
  },
  getReportTotalFoliosPCI: async (querys) => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pci/detail`, querys)
    const response = await fetchManager(url)
    return response

    //const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pci/detail`)
    //return  response
  },
  reportTotalPRGEH: async () => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/prgeh/total/export`)
    const response = await fetchManager(url, { isFile: true, includeBlobAndFileNameHeader: true })
    return response
  },
  reportDetailPRGEH: async () => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/prgeh/detail/export`)
    const response = await fetchManager(url, { isFile: true, includeBlobAndFileNameHeader: true })
    return response
  },
  reportDetailPDD: async () => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pdd/detail/export`);
    const response = await fetchManager(url, { isFile: true, includeBlobAndFileNameHeader: true })
    return response
  },
  reportDetailPDDC: async () => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pddc/detail/export`);
    const response = await fetchManager(url, { isFile: true, includeBlobAndFileNameHeader: true })
    return response
  },
  reportDetailPCI: async (querys) => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pci/detail/export`, querys)
    const response = await fetchManager(url, { isFile: true, includeBlobAndFileNameHeader: true })
    return response

    //const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/pci/detail/export`, { isFile: true })
    //return response
  },
  getReportTotalFoliosPC: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/consolidado/detail`)
    return response
  },
  getReportUnassociatedMSDetail: async () => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/reports/unassociated-ms/detail`)
    return response
  },
  reportUnassociatedMSDetail: async () => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/unassociated-ms/detail/export`)
    const response = await fetchManager(url, { isFile: true, includeBlobAndFileNameHeader: true })
    return response
  },
  reportDetailPC: async () => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/reports/consolidado/detail/export`)
    const response = await fetchManager(url, { isFile: true, includeBlobAndFileNameHeader: true })
    return response
  },
}
